import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import type { LocalizedString } from "../Locale.js";
import { TShirtSize } from "../TShirtSize.js";

export const tShirtSizeNameMap: Record<TShirtSize, LocalizedString> = {
	[TShirtSize.Xs]: sameValueForEveryLocale("XS"),
	[TShirtSize.S]: sameValueForEveryLocale("S"),
	[TShirtSize.M]: sameValueForEveryLocale("M"),
	[TShirtSize.L]: sameValueForEveryLocale("L"),
	[TShirtSize.Xl]: sameValueForEveryLocale("XL"),
	[TShirtSize.Xxl]: sameValueForEveryLocale("2XL"),
	[TShirtSize.Xxxl]: sameValueForEveryLocale("3XL"),
};
